import { render } from "./k-app-sidebar.vue?vue&type=template&id=61c0b7b4"
import script from "./k-app-sidebar.vue?vue&type=script&lang=js"
export * from "./k-app-sidebar.vue?vue&type=script&lang=js"

import "./k-app-sidebar.vue?vue&type=style&index=0&id=61c0b7b4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__